import { Checkbox } from 'antd';
import cn from 'classnames';
import { produce } from 'immer';
import React from 'react';

import { ReactComponent as ArrowDown } from '@/app/_icons/arrow-down.svg';
import { KIA_ID } from '@/constants/used-cars/used-cars.constants';
import { ChildFilter, ParentFilter } from '@/types/filters/filters.types';

import { Option } from '../option/option';

import styles from './group-heading.module.scss';

export const GroupHeading: React.FC<{
  selectOption: (optionToUpdate: ParentFilter | ChildFilter) => void;
  option: ParentFilter;
  hideText: string;
  openText?: string;
  activeCarType?: string;
  setOptionsState: (
    updateFn: (prevState: ParentFilter[]) => ParentFilter[],
  ) => void;
}> = ({
  option,
  selectOption,
  hideText,
  setOptionsState,
  openText,
  activeCarType,
}) => {
  const openCloseLabel = option.isOpened ? hideText : openText;
  const hasChildren = option?.children?.length! > 0;
  const isNotAllSubOptionsChecked = option?.children?.some(
    (option) => option.isChecked === false,
  );
  const isAllSubOptionsUnchecked = option?.children?.every(
    (option) => option.isChecked === false,
  );
  const isAnySubOptionsChecked = option?.children?.some(
    (option) => option.isChecked === true,
  );

  function toggleOpen(optionToUpdate: ParentFilter) {
    setOptionsState((options: ParentFilter[]) => {
      return produce(options, (draftOptions: ParentFilter[]) => {
        const option = draftOptions.find(
          (option: ParentFilter) => option.id === optionToUpdate.id,
        );

        (option as ParentFilter).isOpened = !option?.isOpened;
      });
    });
  }

  let vehiclesList = option?.vehicles;

  if (activeCarType && vehiclesList) {
    switch (activeCarType) {
      case '3':
        if (option.id.toString() !== KIA_ID.toString()) {
          vehiclesList = [];
        } else {
          vehiclesList = option?.vehicles?.filter(
            (vehicle) => (vehicle as any).type === activeCarType,
          ) as any;
        }
        break;
      default:
        vehiclesList = option?.vehicles;
        break;
    }
  }

  return vehiclesList?.length || !activeCarType ? (
    <>
      <div
        className={cn(styles.groupHeading, {
          [styles.groupHeadingSelected as string]: option?.isOpened,
          [styles.groupHeadingOptionChecked as string]: isAnySubOptionsChecked,
        })}
      >
        <Checkbox
          className={styles.groupHeadingInput}
          checked={option.isChecked}
          indeterminate={!isAllSubOptionsUnchecked && isNotAllSubOptionsChecked}
          onChange={() => {
            selectOption(option);
          }}
        />
        <div
          className={styles.groupHeadingContent}
          onClick={() => {
            hasChildren && toggleOpen(option);
          }}
        >
          <span>{option.name}</span>
          {vehiclesList && (
            <span className={styles.groupHeadingAmount}>
              ({vehiclesList.length})
            </span>
          )}
          {hasChildren && (
            <>
              <span className={styles.groupHeadingCloseLabel}>
                {openCloseLabel}
              </span>
              <ArrowDown
                className={cn(styles.groupHeadingArrow, {
                  [styles.groupHeadingArrowOpened as string]: option.isOpened,
                })}
              />
            </>
          )}
        </div>
      </div>
      {option.isOpened &&
        option.children?.map((option) => (
          <Option
            key={option.id}
            option={option}
            selectOption={() => selectOption(option)}
            activeCarType={activeCarType}
          />
        ))}
    </>
  ) : null;
};
